import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  useElements,
  useStripe,
  Elements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import axios from "axios";
import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { CreateConsultation, url } from "../api/index";
import LoadingComponent from "../Components/LoadingComponent";
const STRIPE_OPTIONS = {};

const options = {
  style: {
    base: {
      fontSize: "16px",
    },
    invalid: {
      color: "#9e2146",
    },
  },
};
const Payment = ({
  price,
  show,
  setShow,
  setStep,
  amount,
  temp,
  consultationType,
  pubKeyStripe,
}) => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [consultationId, setConsultationId] = useState(temp?._id);
  const [data, setData] = useState({
    card_number: false,
    card_exp: false,
    cvc: false,
  });

  const stripe = useStripe();
  const elements = useElements();

  const token = localStorage.getItem("token");

  const { mutate } = useMutation(CreateConsultation, {
    onSuccess: (data) => {
      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Consultation Created Successfully!",
        showConfirmButton: false,
        timer: 2000,
      }).then(() => {
        setLoading(false);
        history.push("/dashboard/allconsultations");
      });
    },
    onError: (error) => {
      console.log(error);
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Consultation Created Failed!",
        text: error?.response?.data?.message,
        showConfirmButton: false,
        timer: 2000,
      });
      setLoading(false);
    },
  });

  // console.log(temp, "temp");

  useEffect(async () => {
    try {
      let calculatedPrice = null;
      if (consultationType === "phone_call") {
        calculatedPrice = Math.round(amount?.audioCall * 100);
      } else if (consultationType === "video_call") {
        calculatedPrice = Math.round(amount?.videoCall * 100);
      } else {
        calculatedPrice = Math.round(amount?.writtenReportAnalysis * 100);
      }
      setLoading(true);
      const paymentResponse = await axios.post(
        `${url}/payment/pay`,
        { amount: calculatedPrice ? calculatedPrice : parseInt(price) * 100 },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log(paymentResponse);
      STRIPE_OPTIONS.clientSecret = paymentResponse.data.client_secret;
      // console.log("clientSecret:", STRIPE_OPTIONS.clientSecret); // Add this line

      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  }, [amount]);

  const submitHandler = async (e) => {
    let catchResponse;

    e.preventDefault();
    try {
      let price = null;
      if (consultationType === "phone_call") {
        price = amount?.audioCall;
      } else if (consultationType === "video_call") {
        price = amount?.videoCall;
      } else {
        price = amount?.writtenReportAnalysis;
      }
      let res;
      if (consultationType === "written_report_analysis") {
        res = await axios.patch(
          `${url}/consultations/update-written-report`,
          {
            amount: price,
            consultationId: temp?.reportId || temp?._id,
            status: true,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        res = await axios.put(
          `${url}/consultations/updateConsultation`,
          { amount: price, consultationId: temp?.data?._id, status: true },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (res?.status === 200 || res?.status === 201) {
        const clientSecret = STRIPE_OPTIONS.clientSecret;
        console.log(STRIPE_OPTIONS.clientSecret);
        try {
          if (!clientSecret) {
            setLoading(false);
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: "Payment Failed!",
              text: "There is some error while payment processing",
              showConfirmButton: false,
              timer: 2000,
            });
          }

          if (!stripe || !elements) {
            return;
          }

          const cardNumberElement = elements.getElement(CardNumberElement);
          console.log("card number", cardNumberElement);
          let result;
          try {
            result = await stripe.confirmCardPayment(clientSecret, {
              payment_method: {
                card: cardNumberElement,
              },
            });
          } catch (error) {
            console.log(error);
          }

          console.log("result", result);

          if (result.error) {
            setLoading(false);
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: "Payment Failed!!!",
              text: result?.error?.response?.data?.message,
              showConfirmButton: false,
              timer: 2000,
            });
            setLoading(true);
            if (consultationType === "written_report_analysis") {
              catchResponse = await axios.patch(
                `${url}/consultations/update-written-report`,
                { consultationId: temp?.reportId || temp?._id, status: false },
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                  },
                }
              );
            } else {
              catchResponse = await axios.patch(
                `${url}/consultations/delete-consultation`,
                { consultationId: temp?.data?._id },
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                  },
                }
              );
            }

            if (
              catchResponse?.status === 201 ||
              catchResponse?.status === 200
            ) {
              console.log("catchResponse", res?.response);
              setLoading(false);
              Swal.fire({
                position: "top-end",
                icon: "info",
                title: "Consultation is booked with payment failed!",
                text: "Please retry again within 30 minutes to confirm your slot!",
                showConfirmButton: false,
                timer: 2500,
              });
              history.push("/dashboard");
            } else {
              console.log(catchResponse);
              setLoading(false);
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Couldn't proceed.",
                text: catchResponse?.response?.data?.message,
                showConfirmButton: false,
                timer: 2000,
              });
            }
            setLoading(false);
            history.push("/dashboard");
          } else {
            if (result.paymentIntent.status === "succeeded") {
              try {
                console.log("payment succeeded");
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: "Payment success",
                  showConfirmButton: false,
                  timer: 2000,
                })
                  .then(() =>
                    Swal.fire({
                      position: "top-end",
                      icon: "success",
                      title:
                        consultationType === "written_report_analysis"
                          ? "Your Report is under review"
                          : "Consultation has been booked successfully!",
                      showConfirmButton: false,
                      timer: 2000,
                    })
                  )
                  .then(() => {
                    if (consultationType === "written_report_analysis") {
                      axios
                        .get(
                          `${url}/consultations/send-payment-status-mail/${
                            temp?._id
                          }&${true}`,
                          {
                            headers: {
                              "Content-Type": "application/json",
                              Authorization: `Bearer ${token}`,
                            },
                          }
                        )
                        .then((res) => console.log(res));
                    } else {
                      axios
                        .get(
                          `${url}/consultations/send-payment-status-mail/${
                            temp?.data?._id
                          }&${true}`,
                          {
                            headers: {
                              "Content-Type": "application/json",
                              Authorization: `Bearer ${token}`,
                            },
                          }
                        )
                        .then((res) => console.log(res));
                    }
                    setLoading(false);
                    history.push("/dashboard/allconsultations");
                  });
              } catch (error) {
                Swal.fire({
                  position: "top-end",
                  icon: "error",
                  title: "Consultation booking failed!!!",
                  text: error?.response?.data?.message,
                  showConfirmButton: false,
                  timer: 2000,
                });
                setLoading(false);
                setShow(false);
                history.push("/dashboard");
              }
            } else {
              setLoading(false);
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Payment Failed!!!",
                text: "There is some error while payment processing",
                showConfirmButton: false,
                timer: 2000,
              });
              history.push("/dashboard");
            }
          }
        } catch (error) {}
      } else {
        console.log("status not updated, payment failed", res.response);
        setLoading(false);
        history.push("/dashboard");
      }
    } catch (e) {
      console.log("status not update");
      setLoading(false);
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Consultation Failed!",
        text: e?.response?.data?.message,
        showConfirmButton: false,
        timer: 2000,
      });
      history.push("/dashboard");
    }
  };

  return (
    <Modal show={show}>
      <PaymentForm
        loading={loading}
        setData={setData}
        data={data}
        setStep={setStep}
        submitHandler={submitHandler}
        price={price}
        show={show}
        options={options}
        CardNumberElement={CardNumberElement}
        CardExpiryElement={CardExpiryElement}
        CardCvcElement={CardCvcElement}
      />
    </Modal>
  );
};

const PaymentForm = ({
  loading,
  setData,
  data,
  show,
  setStep,
  submitHandler,
  price,
  options,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
}) => {
  return (
    <div className="shadow-lg modal-bg">
      {!loading ? (
        <>
          <h1 className="mb-4 clrmod">Card Information</h1>

          <div className="form-group">
            <label
              style={{ fontFamily: "Poppins", fontSize: "14px" }}
              htmlFor="card_num_field"
            >
              Card Number
            </label>
            <CardNumberElement
              type="text"
              id="card_num_field"
              className="form-control mt-[5px] mb-[10px]"
              options={options}
              onChange={(e) => setData({ ...data, card_number: e.complete })}
            />
          </div>

          <div className="form-group">
            <label
              style={{ fontFamily: "Poppins", fontSize: "14px" }}
              htmlFor="card_exp_field"
            >
              Card Expiry
            </label>
            <CardExpiryElement
              type="text"
              id="card_exp_field"
              className="form-control mt-[5px] mb-[10px]"
              options={options}
              onChange={(e) => setData({ ...data, card_exp: e.complete })}
            />
          </div>

          <div className="form-group">
            <label
              style={{ fontFamily: "Poppins", fontSize: "14px" }}
              htmlFor="card_cvc_field"
            >
              Card CVC
            </label>
            <CardCvcElement
              type="text"
              id="card_cvc_field"
              className="form-control mt-[5px] mb-[10px]"
              options={options}
              onChange={(e) => setData({ ...data, cvc: e.complete })}
            />
          </div>
          <div style={{ float: "right", paddingTop: "15px" }}>
            <button
              disabled={loading ? true : false}
              id="pay_btn"
              onClick={() => setStep(!show)}
              className="btn btn-block py-3 jjii"
            >
              Close
            </button>
            <button
              disabled={
                !data.card_number || !data.card_exp || !data.cvc || loading
                  ? true
                  : false
              }
              id="pay_btn"
              onClick={submitHandler}
              className="btn btn-block py-3 uuuu "
            >
              Pay ${price}
            </button>
          </div>
        </>
      ) : (
        <LoadingComponent />
      )}
    </div>
  );
};

const WrappedPayment = ({
  price,
  show,
  setStep,
  amount,
  temp,
  consultationType,
  pubKeyStripe,
}) => {
  const stripePromise = loadStripe(pubKeyStripe);

  return (
    <Elements stripe={stripePromise}>
      <Payment
        price={price}
        show={show}
        setStep={setStep}
        amount={amount}
        temp={temp}
        consultationType={consultationType}
        pubKeyStripe={pubKeyStripe}
      />
    </Elements>
  );
};

export default WrappedPayment;
